import React, { useState } from 'react';
import { object, string, bool } from 'prop-types';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';

import styles from './InfoGrayBox.module.scss';

const cx = classNames.bind(styles);

const InfoGrayBox = ({ data, title, labels, isTechDocuments }) => {
  const listLimit = 8;
  const totalProductData = data && data.product_ids;
  const defaultProducts =
    !!totalProductData &&
    !!totalProductData.length &&
    totalProductData.slice(0, listLimit);
  const [productData, setData] = useState(defaultProducts);
  const [isMoreItems, setStatus] = useState(true);
  const showMore = () => {
    setData(
      !isMoreItems ? data.product_ids.slice(0, listLimit) : data.product_ids
    );
    setStatus(!isMoreItems);
  };

  return (
    <div className={cx('gray-box')}>
      <h2 className={cx('box-title')}>{title}</h2>
      <div className={cx('box-content')}>
        {data.lob && isTechDocuments && (
          <div className={cx('row')}>
            <div className={cx('cell', 'cell-title', 'cell-fixed-width')}>
              {labels.lineOfBusinessLabel}
            </div>
            <div className={cx('cell', 'cell-description')}>{data.lob}</div>
          </div>
        )}
        {data.product_family && !!data.product_family.length && isTechDocuments && (
          <div className={cx('row')}>
            <div className={cx('cell', 'cell-title', 'cell-fixed-width')}>
              {labels.productFamilyLabel}
            </div>
            <div className={cx('cell', 'cell-description')}>
              {data.product_family.map((item, i) => {
                return data.product_family.length !== i + 1
                  ? `${item}, `
                  : item;
              })}
            </div>
          </div>
        )}
        {data.product_name && isTechDocuments && (
          <div className={cx('row')}>
            <div className={cx('cell', 'cell-title')}>
              {labels.bulletinProductNameLabel}
            </div>
            <div className={cx('cell', 'cell-description')}>
              {data.product_name}
            </div>
          </div>
        )}
        {data.brand && (
          <div className={cx('row')}>
            <div className={cx('cell', 'cell-title', 'cell-fixed-width')}>
              {labels.bulletinBrandLabel}
            </div>
            <div className={cx('cell', 'cell-description')}>{data.brand}</div>
          </div>
        )}
        {data.component && (
          <div className={cx('row')}>
            <div className={cx('cell', 'cell-title')}>
              {labels.bulletinComponentLabel}
            </div>
            <div className={cx('cell', 'cell-description')}>
              {data.component}
            </div>
          </div>
        )}
        {totalProductData && totalProductData.length > 0 ? (
          <div className={cx('row-full-size')}>
            <div
              className={cx(
                'cell',
                'cell-title',
                'cell-fixed-width',
                'mobile-full-width'
              )}
            >
              {labels.bulletinProductIdLabel}
            </div>
            <div className={cx('cell', 'cell-description', 'cell-auto')}>
              {productData.map((item, index) => (
                <span key={index}>
                  {index === 0 ? '' : ', '}
                  {item}
                </span>
              ))}

              {totalProductData.length > listLimit && (
                <button
                  type="button"
                  className={cx('btn-more')}
                  onClick={showMore}
                >
                  {isMoreItems ? labels.showMoreLabel : labels.showLessLabel}
                </button>
              )}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

InfoGrayBox.propTypes = {
  data: object.isRequired,
  title: string.isRequired,
  labels: object.isRequired,
  isTechDocuments: bool,
};

InfoGrayBox.defaultProps = {
  isTechDocuments: false,
};

export default withLabels(InfoGrayBox);



// WEBPACK FOOTER //
// ./src/components/InfoGrayBox/InfoGrayBox.js